import React from "react";
import { Card, Col, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../../helpers/utility";
import useQuery from "../../../../hooks/useQuery";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";

const SpecialAreas = ({ data }) => {
  const navigate = useNavigate();
  const params = useQuery();
  const role = getCookie(Role)?.toLowerCase()?.trim();
  const isDoctor = role?.includes("doctor");

  const formatDaysAgo = (orderDate) => {
    if (!orderDate) return null;
    const now = new Date();
    const date = new Date(orderDate);
    const timeDiff = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    return `${timeDiff}d`;
  };

  const getBaseRoute = () =>
    role?.includes("nurse") ? "/nurse/home" : "/doctor/home";

  const goToOrderSheet = (care) => {
    const base =
      `${getBaseRoute()}?` +
      (isDoctor ? `patient-type=${params?.["patient-type"]}&` : "") +
      `status=${params?.status}&patient=${params?.patient}&type=order-sheet`;
    navigate(care ? `${base}&care=${care}` : base);
  };

  const areas = [];

  if (data?.[0]?.catheter) {
    const item = data[0].catheter;
    areas.push({
      key: "catheter",
      title: "Urinary Catheter",
      care: "urinary_catheter_care",
      detail: capitalizeFirstLetter(
        item?.data?.urinary_catheter_type?.replaceAll("_", " ") || "-"
      ),
      days: formatDaysAgo(item?.order_date),
    });
  }

  if (data?.[1]?.central_line) {
    const item = data[1].central_line;
    areas.push({
      key: "central-line",
      title: "Central Line",
      care: "preventive_care",
      detail: capitalizeFirstLetter(
        (
          item?.drug_name ||
          item?.data?.preventive_care_comments ||
          "-"
        )?.replaceAll("_", " ")
      ),
      days: formatDaysAgo(item?.order_date),
    });
  }

  if (data?.[2]?.feeding_tube) {
    const item = data[2].feeding_tube;
    areas.push({
      key: "feeding-tube",
      title: "Feeding Tube",
      care: "feeding_tube",
      detail: capitalizeFirstLetter(
        item?.data?.feeding_tube_type?.replaceAll("_", " ") || "-"
      ),
      days: formatDaysAgo(item?.order_date),
    });
  }

  if (data?.[3]?.pressure_sore_care) {
    const item = data[3].pressure_sore_care;
    const area = capitalizeFirstLetter(
      item?.data?.pressure_sore_area?.replaceAll("_", " ") || "-"
    );
    const grade = capitalizeFirstLetter(
      item?.data?.pressure_sore_grade?.replaceAll("_", " ") || "-"
    );
    areas.push({
      key: "pressure-sore",
      title: "Pressure Sore",
      care: "pressure_sore",
      detail: `${area} · ${grade}`,
      days: formatDaysAgo(item?.order_date),
    });
  }

  return (
    <Card
      className="special-areas-card"
      title={
        <Typography
          onClick={() => goToOrderSheet()}
          style={{ cursor: isDoctor ? "pointer" : "default" }}
        >
          Special Areas
        </Typography>
      }
      style={{ marginTop: "10px" }}
      styles={{ header: { borderBottom: "none" }, body: { paddingTop: "0px" } }}
    >
      <div className="special-areas-grid">
        {areas.map((area) => (
          <button
            type="button"
            key={area.key}
            className="special-areas-chip"
            onClick={() => (isDoctor ? goToOrderSheet(area.care) : undefined)}
            style={{ cursor: isDoctor ? "pointer" : "default" }}
          >
            <span className="special-areas-chip__top">
              <span className="special-areas-chip__title">{area.title}</span>
              {area.days != null && (
                <span className="special-areas-chip__days">{area.days}</span>
              )}
            </span>
            <span className="special-areas-chip__detail">{area.detail}</span>
          </button>
        ))}
      </div>
    </Card>
  );
};

export default SpecialAreas;
